import { DataNode } from './treeSelect';

export function formatTreeData(
  treeData: any[],
  titleName?: string,
  valueName?: string,
  childrenName?: string,
  allSelect?: boolean,
  treeValues?: any[],
): DataNode[] {
  let titleKey = titleName || 'title';
  let valuekey = valueName || 'value';
  let childrenkey = childrenName || 'children';
  let result: DataNode[] = [];
  if (Array.isArray(treeData) && treeData.length) {
    result = treeData.map(item => {
      const currentTreeValue: any[] = [...(treeValues || []), item[valuekey]];
      return {
        ...item,
        title: item[titleKey],
        value: item[valuekey],
        treeValues: currentTreeValue,
        disabled:
          !allSelect && !!(item[childrenkey] && item[childrenkey].length),
        children: formatTreeData(
          item[childrenkey],
          titleName,
          valueName,
          childrenName,
          allSelect,
          currentTreeValue,
        ),
      };
    });
  }
  return result;
}

// export function filterTreeData(treeData: DataNode[], keyword?: string) {
//   if (!keyword) return treeData;
//   let result: DataNode[] = [];
//   treeData.forEach(item => {

//     if (item.children) {
//       result.children = filterTreeData(item.children, keyword);
//     }
//   });
//   return result;
// }
